<template>
  <EmailPtyjsftj />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
